import React from "react";
import { UpsellPanelSteps } from "../../../../constants/upsellPanelEnumsAndConstants";

export const Step11LockedContent = ({
    currentStep,
    constants,
    customerServicePhone
}) => {
    if(currentStep !== UpsellPanelSteps.Step11PastDueStatusPaymentDetailsUpdated){
        return null;
    }
    return (
        <div className="step11 locked-content-msg">
            <h3>You've recently updated your payment details.</h3>
            <p>
                It may take a few minutes to update your subscription details. During this time, you will not be able to view locked content.
            </p>
            <br />
            <p>
                If you are still having trouble viewing content after 10 minutes, try logging out of your account and logging back in.
            </p>
            <br />
            <p>Still having trouble viewing content?</p>
            <p>
                Please contact Member Services on{" "}
                <a href="mailto:support@investsmart.com.au">support@investsmart.com.au</a>{" "}
                or{" "}
                <a href={`tel:${customerServicePhone.replace(/\s/g, "")}`}>
                    {customerServicePhone}
                </a>
            </p>
        </div>
    );
};

